export default {
    email: {
        required: true,
        email: true
    },
    policyCheck: {
        required: true
    },
}